import { render } from "./AddressManagementPage.vue?vue&type=template&id=1abd2292&scoped=true"
import script from "./AddressManagementPage.vue?vue&type=script&lang=js"
export * from "./AddressManagementPage.vue?vue&type=script&lang=js"

import "./AddressManagementPage.vue?vue&type=style&index=0&id=1abd2292&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abd2292"]])

export default __exports__